import React from 'react';
interface TomoItem {
  title: string;
  image: string;
}
const tomos: TomoItem[] = [{
  title: 'TOMO 1 — EL ROL DEL PIVOTE: FUNDAMENTOS Y PERFIL',
  image: 'https://cdn.magicpatterns.com/uploads/v9Acfx9TB1VVyL8tvFxS3M/Tomo_1.png'
}, {
  title: 'TOMO 2 — +15 DRILLS DE LECTURA DE JUEGO Y POSICIONAMIENTO DEFENSIVO',
  image: 'https://cdn.magicpatterns.com/uploads/tpjQHcc4WLfe9ZjdrMSTTQ/tomo_2.png'
}, {
  title: 'TOMO 3 — +15 DRILLS SALIDA DE BALÓN Y CONSTRUCCIÓN DE JUEGO',
  image: 'https://cdn.magicpatterns.com/uploads/7Ct4oKQA58xexqXD1jrt64/tomo_3_.png'
}, {
  title: 'TOMO 4 — PREPARACIÓN FÍSICA: FUERZA Y POTENCIA',
  image: 'https://cdn.magicpatterns.com/uploads/qkRA4jSV23Lo97G5UXVXuk/Tomo_4.png'
}, {
  title: 'TOMO 5 — PREVENCIÓN DE LESIONES Y RECUPERACIÓN',
  image: 'https://cdn.magicpatterns.com/uploads/3iZiJtT8mNbGBvkhzRyaRg/Tomo_5.png'
}, {
  title: 'TOMO 6 — TÁCTICA AVANZADA: SISTEMAS Y VARIANTES',
  image: 'https://cdn.magicpatterns.com/uploads/tEKQfUrzhjBzXZ4hTxZ87e/Tomo_6.png'
}, {
  title: 'TOMO 7 — +10 Ejercicios - PSICOLOGÍA Y LIDERAZGO DEL PIVOTE',
  image: 'https://cdn.magicpatterns.com/uploads/8UqwxLiMTW8fEKnEb4nUgy/Tomo_7.png'
}, {
  title: 'TOMO 8 — PLAN DE ENTRENAMIENTO INTEGRAL Y PERIODIZACIÓN',
  image: 'https://cdn.magicpatterns.com/uploads/hnY24vngHyxhAJRs3ozZJA/Tomo_8.png'
}];
export function TomoCarousel() {
  return <ol className="space-y-3" aria-label="Lista de tomos incluidos" data-id="element-234" data-mp="209fayxkuginb">
      {tomos.map((tomo, index) => <li key={tomo.title} className="flex items-center gap-4 rounded-xl border border-green-200 bg-white p-3 shadow-sm" data-id="element-235" data-mp="1w9myi9sbxsco" data-mpi={index}>
          <div className="h-20 w-20 flex-shrink-0 overflow-hidden rounded-lg bg-black p-0.5" data-id="element-236" data-mp="257yw4vrm5qem">
            <img src={tomo.image} alt={`Portada de ${tomo.title}`} className="h-full w-full object-contain" data-id="element-237" data-mp="3llp44dlusytj" />
          </div>
          <div className="min-w-0" data-id="element-238" data-mp="3ood3nxt3ljbu">
            <p className="mb-1 text-xs font-black tracking-[0.16em] text-green-700" data-id="element-239" data-mp="3on1rpapi159n">
              TOMO {index + 1} DE 8
            </p>
            <h4 className="text-sm font-black leading-snug text-gray-900 md:text-base" data-id="element-240" data-mp="3srrjooh1dzpa">
              {tomo.title}
            </h4>
          </div>
        </li>)}
    </ol>;
}